import { useTheme } from '@mui/material'
import { useContextState } from '../../../../../../../../hooks/theme'


export const useStyles = () => {
  const { colors: color } = useContextState()
  const { breakpoints } = useTheme()
  return {
    arrow:{
      marginLeft: '-30px'
    },
    buttonsContainer: {
      marginTop:'20px',
      display: 'flex',
      width: '100%',
      justifyContent: 'space-between',
      alignItems: 'center',
      '& .back': {
        width: '80px',
        height: '36px',
      },
      '& .next': {
        borderRadius: '4px',
      },
    },
    action: {
      width: '100%',
      display: 'flex',
      justifyContent: 'start',
      flexWrap: 'wrap',
      '& .MuiCheckbox-root': {
        margin: 0
      }
    },
    user: {
      fontSize: '12px',
      color: color.color9,
      width: '100%',
    },
    titleEvidences: {
      fontSize: '16px',
      fontWeight: '600',
      color: color.color13,
    },
  }
}
